import { render, staticRenderFns } from "./sampleTipsDialog.vue?vue&type=template&id=c5849866&scoped=true"
import script from "./sampleTipsDialog.vue?vue&type=script&lang=js"
export * from "./sampleTipsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5849866",
  null
  
)

export default component.exports